export default "__VITE_ASSET__8sWRvyOp__"